export class FormPropertyKey{

  static PropertyIdEmail = 10000;
  static PropertyIdNameLast = 10001;
  static PropertyIdNameFirst = 10002;
  static PropertyIdCompany = 10003;
  static PropertyIdDepartment = 10004;
  static PropertyIdPosition = 10005;
  static PropertyIdTel = 10006;
  static PropertyIdContent = 10007;
  static PropertyPrivacyConsent = 9000;
  static PropertyIdLeadSource = 9001;

  static RequiredTrue = 1;
  static RequiredFalse = 2;

  static InputTypeText = 1;
  static InputTypeTextarea = 2;
  static InputTypeEmail = 3;
  static InputTypeSelectDropdown = 4; // ドロップダウン（1つのみ）
  static InputTypeSelectCheckbox = 5; // チェックボックス（複数可）
  static InputTypeSelectRadio = 6; // ラジオボタン（1つのみ）
  static InputTypeSingleCheckbox = 7; // チェックボックス（単一）
  static InputTypeHidden = 8; // 非表示

  static InputTypeTextMaxLength = 100;
  static InputTypeTextareaMaxLength = 1000;
  static InputTypeEmailMaxLength = 100;

  id: number;
  value: string;
  prospectKeyId: number;
  inputType: number;
  // dataType: 1 | 2; // 1:DATA_TYPE_TEXT, 2:DATA_TYPE_EMAIL
  label: string;
  orderIndex: number;
  required: number; // 1:REQUIRED_TRUE, 2: REQUIRED_FALSE
  options: Array<FormPropertyKeyOption> = [];
  width: string = "w-full";
  beforeText?: string;
  afterText?: string;
  defaultValue?: string;

  constructor(object = null){
    if(object){
      this.set(object);
    }
  }

  set(object){
    if(object.id){
      this.id = object.id;
    }
    if(object.value){
      this.value = object.value;
    }
    if(object.prospectKeyId){
      this.prospectKeyId = object.prospectKeyId;
    }
    if(object.inputType){
      this.inputType = object.inputType;
    }
    // if(object.dataType){
    //   this.dataType = object.dataType;
    // }
    if(object.label){
      this.label = object.label;
    }
    if(object.orderIndex){
      this.orderIndex = object.orderIndex;
    }
    if(object.required){
      this.required = object.required;
    }
    if(object.options != null){
      this.options = object.options.map((optionObject) => {
        return {
          key: optionObject.key ?? null,
          value: optionObject.value,
          label: optionObject.label,
          isDefault: optionObject.isDefault,
        };
      });
    }
    if(object.width){
      this.width = object.width;
    }
    else{
      if(object.id == FormPropertyKey.PropertyIdNameLast || object.id == FormPropertyKey.PropertyIdNameFirst){
        this.width = "w-half";
      }
      else{
        this.width = "w-full";
      }
    }
    if(object.beforeText){
      this.beforeText = object.beforeText;
    }
    if(object.afterText){
      this.afterText = object.afterText;
    }
    if(object.defaultValue){
      this.defaultValue = object.defaultValue;
    }
  }

  // orderIndexで並び替える
  static compareOrderIndex(aFormProperty:FormPropertyKey, bFormProperty:FormPropertyKey) {

    let comparison = 0;
    if (aFormProperty.orderIndex == bFormProperty.orderIndex){
      comparison = -1;
    }
    else if (aFormProperty.orderIndex > bFormProperty.orderIndex){
      comparison = 1;
    }
    else if (aFormProperty.orderIndex < bFormProperty.orderIndex){
      comparison = -1;
    }
    return comparison;
  }
}

export interface FormPropertyKeyOption{
  key?:string,
  value:string,
  label:string,
  isDefault:0 | 1;
}
